import { render, staticRenderFns } from "./SubsetsPerformance.vue?vue&type=template&id=0c334e5a&"
import script from "./SubsetsPerformance.vue?vue&type=script&lang=js&"
export * from "./SubsetsPerformance.vue?vue&type=script&lang=js&"
import style0 from "./SubsetsPerformance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports